import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './assets/css/App.css';
import './i18n/autoTranslate';

import App from './App';
import { RoleProvider } from './contexts/RoleContext';
import { ActiveTabProvider } from 'contexts/ActiveTabContext';
import { AuthProvider } from 'contexts/AuthContext';
import { TranslationProvider } from './i18n/TranslationProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <TranslationProvider>
    <BrowserRouter>
      <RoleProvider>
        <ActiveTabProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ActiveTabProvider>
      </RoleProvider>
    </BrowserRouter>
  </TranslationProvider>
);
